export const FormContainer = ({ children }: { children: React.ReactNode }) => {
  return <div className="flex flex-col w-full gap-1.5">{children}</div>;
};
